import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  formatTime,
  getTodayTime,
  getTotalTime,
  getTotalTodayTime,
  getTotalYesterdayTime,
  getTotalThisWeekTime,
} from '../utils/timeUtils';

const SURFACE = 'var(--color-surface)';
const BORDER  = 'var(--color-border)';

const TimeStats: React.FC = () => {
  // Tick every second so a live session updates this view
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const quantTime   = parseInt(localStorage.getItem('gre_quant_time')        || '0', 10);
  const vocabTime   = parseInt(localStorage.getItem('gre_flashcard_time')    || '0', 10)
                    + parseInt(localStorage.getItem('gre_synonym_time')       || '0', 10)
                    + parseInt(localStorage.getItem('gre_fast_attack_time')   || '0', 10)
                    + parseInt(localStorage.getItem('gre_hard_terms_time')    || '0', 10);

  const stats = [
    { label: 'Quant Time',       value: formatTime(quantTime) },
    { label: 'Quant Today',      value: formatTime(getTodayTime('quant')) },
    { label: 'Vocab Time',       value: formatTime(vocabTime) },
    { label: 'Vocab Today',      value: formatTime(
        getTodayTime('flashcard') +
        getTodayTime('synonym')   +
        getTodayTime('fastattack') +
        getTodayTime('hardterms')
      )
    },
    { label: 'Total All Modes',  value: formatTime(getTotalTime()) },
    { label: 'Total Today',      value: formatTime(getTotalTodayTime()) },
    { label: 'Total Yesterday',  value: formatTime(getTotalYesterdayTime()) },
    { label: 'Total This Week',  value: formatTime(getTotalThisWeekTime()) },
  ];

  return (
    <div style={{ padding: '16px', maxWidth: '600px', margin: '0 auto' }}>
      <Helmet>
        <title>Time & Stats | Phrenos</title>
        <meta name="description" content="View your Phrenos study time and statistics across all study modes." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <h2 style={{ margin: '0 0 20px', fontSize: '22px', fontWeight: 800, color: 'var(--color-text)' }}>
        Time & Stats
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10px',
        }}
      >
        {stats.map(stat => (
          <div
            key={stat.label}
            style={{
              backgroundColor: SURFACE,
              border: `1px solid ${BORDER}`,
              borderRadius: '16px',
              padding: '14px 16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
            }}
          >
            <span style={{
              fontSize: '11px',
              color: 'var(--color-text-muted)',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontWeight: 600,
            }}>
              {stat.label}
            </span>
            <span style={{ fontSize: '18px', fontWeight: 800, color: 'var(--color-text)' }}>
              {stat.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TimeStats;
